import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  BulkUploadExtractData,
  BulkUploadSubmitData,
  BulkUploadValidationData,
  RequestResponse,
} from '@/types';
import type {
  BulkUploadDraftPayload,
  BulkUploadRowsPayload,
  BulkUploadSubmitPayload,
} from './payload';

export const extractBulkUploadFile = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axiosInstance.post<
    RequestResponse<BulkUploadExtractData>
  >(endpoints.productsBulkUploadExtract, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const validateBulkUpload = async (payload: BulkUploadRowsPayload) => {
  const response = await axiosInstance.post<
    RequestResponse<BulkUploadValidationData>
  >(endpoints.productsBulkUploadValidate, payload);

  return response.data;
};

export const updateBulkUploadDraft = async (
  payload: BulkUploadDraftPayload
) => {
  const response = await axiosInstance.patch<
    RequestResponse<BulkUploadValidationData>
  >(endpoints.productsBulkUploadDraft, payload);

  return response.data;
};

export const fetchBulkUploadDraft = async () => {
  const response = await axiosInstance.get<
    RequestResponse<BulkUploadValidationData>
  >(endpoints.productsBulkUploadDraft);

  return response.data;
};

export const submitBulkUpload = async (payload: BulkUploadSubmitPayload) => {
  const response = await axiosInstance.post<
    RequestResponse<BulkUploadSubmitData>
  >(endpoints.productsBulkUpload, payload);

  return response.data;
};
